
import { useState, useEffect } from 'react';
import translations from '../translations'
import { UrlUtils } from "../urlUtils"
import LocalizationContext from '../contexts/localizationContext'


const LocalizationProvider = ({ children }) => {
  const [currentLanguage, setCurrentLanguage] = useState(() => 
    UrlUtils.getLanguageFromPath()
  );
  
  const t = (key) => {
    const translation = translations[currentLanguage]?.[key];
    if (!translation) {
      console.warn(`Traduzione mancante per la chiave: ${key} nella lingua: ${currentLanguage}`);
      return key;
    }
    return translation;
  };
  
  const navigateTo = (section, language = currentLanguage) => {
    const url = UrlUtils.buildLocalizedUrl(language, section);
    window.history.replaceState({}, '', url);
    setCurrentLanguage(language);
  };
  
  const changeLanguage = (newLanguage) => {
    const section = UrlUtils.getSectionWithParamsFromPath()

    if (translations[newLanguage]) {
      navigateTo(section, newLanguage);
    } else {
      console.warn(`Lingua non supportata: ${newLanguage}`);
    }
  };
  
  const getSupportedLanguages = () => Object.keys(translations);
  
  const getLocalizedUrl = (section, language = currentLanguage) => {
    return UrlUtils.buildLocalizedUrl(language, section);
  };
  
  return (
    <LocalizationContext.Provider value={{ 
      currentLanguage, 
      changeLanguage,
      t, 
      getSupportedLanguages,
      getLocalizedUrl
    }}>
      {children}
    </LocalizationContext.Provider>
  );
};

export default LocalizationProvider